export const USER_DATA_LOCAL_STORAGE = 'userData';
